// FormServiceDelete.jsx
import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import BaseForm from '../../app/components/BaseForm';

const FormServiceDelete = ({
  isOpen,
  onClose,
  onConfirm,
  item,
  title = "Excluir gráfico",
  description = "Esta ação não poderá ser desfeita. Todos os dados associados a este gráfico serão permanentemente removidos.",
  confirmationMessage,
}) => {
  if (!item) return null;

  const handleSubmit = () => {
    onConfirm(item.id);
  };

  const fields = [
    {
      id: "confirmacao",
      label: "Confirmação",
      type: "info",
      content: confirmationMessage || `Você está prestes a excluir o "${item.titulo || item.name}".`,
    },
    {
      id: "aviso",
      label: "Aviso",
      type: "warning",
      content: description,
    },
  ];

  const renderFormSection = (sectionFields) => {
    return (
      <div className="space-y-4">
        {sectionFields.map((field, index) => (
          <div
            key={field.id}
            className="space-y-2"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 + index * 0.05 }}
          >
            {field.type === 'info' && (
              <div className="bg-gray-50 p-4 rounded-md">
                <p className="text-gray-700">{field.content}</p>
              </div>
            )}
            {field.type === 'warning' && (
              <div className="bg-red-50 p-4 rounded-md border border-red-200">
                <div className="flex items-start">
                  <FiAlertTriangle className="text-red-500 mt-0.5 mr-2 flex-shrink-0" />
                  <p className="text-red-700 text-sm">{field.content}</p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const renderFormFields = () => (
    <div className="max-h-[calc(80vh-120px)] overflow-y-auto px-1">
      <div className="mb-4 pb-2">
        <h3 className="text-md font-medium text-gray-700">Confirmação de Exclusão</h3>
      </div>
      {renderFormSection(fields)}
    </div>
  );

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title}
      icon={<FiAlertTriangle className="w-6 h-6" />}
      primaryColor="#EF4444"
      isValid={true}
      submitButtonText="Excluir"
      cancelButtonText="Cancelar"
    >
      {renderFormFields()}
    </BaseForm>
  );
};

export default FormServiceDelete;
